<div>
  <div class="nav-container-1">
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 tab-container">
        <mat-tab-group (selectedTabChange)="viewTabClick($event)" animationDuration="0ms"
          [(selectedIndex)]="selectedTabIndex">
          <mat-tab label="Engineering Workflow" id="lblEngg"></mat-tab>
          <mat-tab label="PR Workflow" id="lblPR"></mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>

  <div>
    <ssrs-reportviewer [reportserver]="reportServer" [reporturl]="reportUrl" [showparameters]="showParameters"
      [parameters]="parameters" [language]="language" [width]="width" [height]="height" [toolbar]="toolbar">
    </ssrs-reportviewer>
  </div>
</div>